import React from 'react';
import DatePicker from "react-datepicker";
import {addDays, startOfDay, format, parse} from "date-fns";
import {DATE_FORMATS} from "../../../constants";

const DateInput = (props) => {
    const {
        name        = '',
        value       = '',
        onChange    = (value) => {},
        disabled    = false
    } = props;

    const parseDate = () => {
        if (!value || value === "") {
            return "";
        }

        return parse(value, DATE_FORMATS.DATE, startOfDay(new Date()));
    }

    const handleUpdate = (newValue) => {
        if (!newValue || newValue === "") {
            onChange('');
        } else {
            onChange(format(newValue, DATE_FORMATS.DATE));
        }
    }

    return (
        <DatePicker
            {...props}
            selected={parseDate()}
            name={name}
            onChange={(newValue) => handleUpdate(newValue)}
            showMonthDropdown
            showYearDropdown
            dropdownMode={"select"}
            current
            isClearable={false}
            closeOnScroll={true}
            showPopperArrow={false}
            className={'datepicker-field'}
            disabled={disabled}
            disabledKeyboardNavigation
            dateFormat={DATE_FORMATS.DATE}
        />
    );
}

export default DateInput;
